import { create } from 'zustand';
import { 
  generateBlogPostAiResponse, 
  GenerateBlogPostResponse,
  generateBlogTitlesAiResponse 
} from '../../../services/getAiResponse';

interface BlogState {
  titlesCache: Record<string, string[]>;
  postsCache: Record<string, GenerateBlogPostResponse>;
  getTitles: (topic: string, language: string, creativity: string) => Promise<string[]>;
  getPost: (title: string, keyword: string | undefined, language: string, creativity: string) => Promise<GenerateBlogPostResponse>;
}

export const useBlogStore = create<BlogState>((set, get) => ({
  titlesCache: {},
  postsCache: {},
  
  getTitles: async (topic, language, creativity) => {
    const cacheKey = `${topic}-${language}-${creativity}`;
    const cachedTitles = get().titlesCache[cacheKey];
    
    if (cachedTitles) {
      return cachedTitles;
    }

    const titles = await generateBlogTitlesAiResponse(topic, language, creativity);
    set((state) => ({
      titlesCache: { ...state.titlesCache, [cacheKey]: titles }
    }));
    return titles;
  },

  getPost: async (title, keyword, language, creativity) => {
    const cacheKey = `${title}-${keyword || ''}-${language}-${creativity}`;
    const cachedPost = get().postsCache[cacheKey];
    
    if (cachedPost) {
      return cachedPost;
    }

    const post = await generateBlogPostAiResponse(title, keyword, language, creativity);
    set((state) => ({
      postsCache: { ...state.postsCache, [cacheKey]: post }
    }));
    return post;
  },
}));